import { MobileOS } from "../../../../models";
import { getMobileOS, notification } from "../../../../services";
import { CHAT_ACCEPT_TYPES, CHAT_FILE_TYPE_DOCUMENT, CHAT_FILE_TYPE_IMAGE, CHAT_MAX_FILE_SIZE_BYTES, CHAT_MAX_FILE_SIZE_MB, CHAT_MAX_FILES_PER_MESSAGE, CHAT_SUPPORTED_DOCUMENT_TYPES, CHAT_SUPPORTED_IMAGE_TYPES } from "../constants";

export const useAttachmentButton = (selectedFiles, setSelectedFiles) => {
  const onAttachmentButtonClick = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.style.display = 'none';

    // Mobile OS detection
    const mobileOS = getMobileOS();
    const isAndroid = mobileOS === MobileOS.android;
    const isIOS = mobileOS === MobileOS.iOS;

    // iOS works better with wildcard types like image/* instead of specific MIME types
    // Android works better with broad wildcards to properly show document picker
    if (isIOS || isAndroid) {
      fileInput.accept = 'image/*,application/pdf';
    } else {
      fileInput.accept = CHAT_ACCEPT_TYPES;
    }

    fileInput.onchange = (e) => {
      const allFiles = Array.from(e.target.files || []);
      const remainingSlots = CHAT_MAX_FILES_PER_MESSAGE - selectedFiles.length;

      // Filter out files that exceed size limit or are unsupported types
      const validFiles = allFiles.filter(file => {
        // Check file size
        if (file.size > CHAT_MAX_FILE_SIZE_BYTES) {
          notification.showError(`Datoteka "${file.name}" prelazi maksimalnu veličinu od ${CHAT_MAX_FILE_SIZE_MB}MB`);
          return false;
        }

        // Check file type
        const isSupported = [...CHAT_SUPPORTED_IMAGE_TYPES, ...CHAT_SUPPORTED_DOCUMENT_TYPES].includes(file.type);
        if (!isSupported) {
          notification.showError(`Datoteka "${file.name}" nije podržana. Dozvoljene su samo slike i PDF dokumenti.`);
          return false;
        }

        return true;
      });

      const files = validFiles.slice(0, remainingSlots);

      if (validFiles.length > remainingSlots) {
        notification.showError(`Dosegli ste maksimalan broj od ${CHAT_MAX_FILES_PER_MESSAGE} datoteka po poruci.`);
      }

      // Handle case where no valid files were selected
      if (files.length === 0) {
        // Clean up
        document.body.removeChild(fileInput);
        return;
      }

      const processedFiles = [];
      let processedCount = 0;
      let hasErrors = false;

      const checkComplete = () => {
        if (processedCount === files.length) {
          if (processedFiles.length > 0) {
            setSelectedFiles([...selectedFiles, ...processedFiles]);
          } else if (hasErrors) {
            notification.showError('Greška pri učitavanju datoteka. Molimo pokušajte ponovo.');
          }
          // Clean up the input element
          document.body.removeChild(fileInput);
        }
      };

      files.forEach(file => {
        const fileType = file.type.includes('image') ? CHAT_FILE_TYPE_IMAGE : CHAT_FILE_TYPE_DOCUMENT;

        const fileWithPreview = {
          file,
          id: `${Date.now()}-${Math.random()}`,
          type: fileType,
          status: 'done',
          originalFileName: file.name
        };

        // Create preview for images
        if (fileType === CHAT_FILE_TYPE_IMAGE) {
          const reader = new FileReader();

          reader.onload = (e) => {
            fileWithPreview.preview = e.target && e.target.result;
            processedFiles.push(fileWithPreview);
            processedCount++;
            checkComplete();
          };

          reader.onerror = () => {
            // On iOS, FileReader can fail silently - this ensures we handle it
            console.error('FileReader error for file:', file.name);
            hasErrors = true;
            processedCount++;
            checkComplete();
          };

          reader.readAsDataURL(file);
        } else {
          processedFiles.push(fileWithPreview);
          processedCount++;
          checkComplete();
        }
      });
    };

    // Append to body to ensure it works on iOS
    document.body.appendChild(fileInput);
    fileInput.click();
  }

  return { onAttachmentButtonClick }
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/hooks/useAttachmentButton.ts